<script setup>
import { Link } from "@inertiajs/vue3";

defineProps({
  href: String,
  as: String,
});
</script>

<template>
  <div>
    <button v-if="as == 'button'" type="submit" class="dropdown-item">
      <slot />
    </button>

    <a v-else-if="as == 'a'" :href="href" class="dropdown-item">
      <slot />
    </a>

    <Link v-else :href="href" class="dropdown-item">
      <slot />
    </Link>
  </div>
</template>

<style lang="scss" scoped>
.dropdown-item {
  @include ff-menu-dropdown;

  display: block;
  width: 100%;
  padding: 0.5rem 1rem;
  text-align: left;

  transition: background-color 150ms ease-in-out;

  &:hover,
  &:focus-visible {
    background-color: var(--clr-bg-accent);
  }

  &:focus-visible {
    --outline-color: var(--clr-primary);
    @include outlined;
  }
}
</style>
